class LocalisationUtility {
	constructor (game, textAsset, language) {
		this.game = game;
		this.SetLanguage(language || "en");
		this.jsonData = this.game.cache.json.get(textAsset);
	}

	SetLanguage (language) {
		if (language == "auto") {
			language = this.LanguageBCPToCode(navigator.language);
		}

		var supportedLanguages = ["en","fr","es","de","pt","hu","ro","pl","bg","ru","nl","cs","no","sv","da","ar","tr","it","es-419","pt-br"];
		this.language = ~supportedLanguages.indexOf(language) ? language : supportedLanguages[0];
	}

	LanguageBCPToCode (bcp) {
		bcp = bcp.substr(0, bcp.indexOf('-'));
		return bcp;
	}

	GetString (key) {
		if (!this.jsonData) { return key; }

		var data = this.jsonData[key];
		if (!data) { return key; }

		var locText = data[this.language]
		if (!locText) { return data["en"]; }

		return locText;
	}
}

export default LocalisationUtility;